import React from 'react'
import PropTypes from 'prop-types'

// extends React.Component is required because of reference in parent
export default class FieldStatus_DropdownOption extends React.Component<any> {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option', 'pill', {
            'highlighted': this.props.isHighlighted
        })

        const valueClasses = Classes({
            'ui5-status-list'                           : !!this.props.option.value,
            ['status-c{0}'.f(this.props.option.color)]  : !!this.props.option.value && !!this.props.option.color,
        })

        return (
            <div className={classes} onClick={this.onClick}>
                <div className={valueClasses}>{this.props.option.label}</div>
            </div>
        )
    }
}